import { Trans } from '@lingui/react';
import { ErrorBoundary } from '@startuptools/ui/ErrorBoundary';
import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { SnrCases } from './components/SnrCases';
import { SnrBonds } from './components/SnrBonds';
import { SnrAuthorizations } from './components/SnrAuthorizations';
import { Suspense } from 'react';

export const Cases = () => {
  return (
    <Stack gap={3}>
      <Suspense>
        <Stack gap={2}>
          <Typography level="h2">
            <Trans id="Case List" />
          </Typography>
          <ErrorBoundary>
            <SnrCases />
          </ErrorBoundary>
        </Stack>
        <Stack gap={2}>
          <Typography level="h2">
            <Trans id="Bonds / Convertibles / Warrants" />
          </Typography>
          <ErrorBoundary>
            <SnrBonds />
          </ErrorBoundary>
        </Stack>
        <Stack gap={2}>
          <Typography level="h2">
            <Trans id="Authorizations" />
          </Typography>
          <ErrorBoundary>
            <SnrAuthorizations />
          </ErrorBoundary>
        </Stack>
      </Suspense>
    </Stack>
  );
};
